<label id="maalestokk">Målestokk = 1:{{ scale | number }}</label>
